<template>
  <div class="pa-5" v-if="products.length && isVisibleTable">
    <div class="text-right">
      <VBtn
        @click="isVisibleTable = false"
        class="mb-1"
        color="primary"
        style="min-width: auto"
      >
        <VIcon>mdi-chevron-right</VIcon>
      </VBtn>
    </div>
    <TableWithFilter
      style="max-height: calc(100vh - 326px)"
      :isFilterable="false"
      :headers="headers"
      :items="products"
    >
      <template #item.unitType="{ item }">
        {{ item.unitType[`name_${$i18n.locale}`] }}
      </template>
      <template #item.action="{ index }">
        <VTooltip
          v-if="$store.getters.isUserAdmin"
          color="#fff"
          left
          nudge-right="10"
          nudge-top="35"
        >
          <template v-slot:activator="{ on, attrs }">
            <VBtn
              v-bind="attrs"
              v-on="on"
              class="new_style"
              @click="removeProduct(index)"
            >
              <vue-icon icon="newTrashIcon"></vue-icon>
            </VBtn>
          </template>
          <span>{{ $t("delete") }}</span>
        </VTooltip>
      </template>
    </TableWithFilter>
    <VBtn
      @click="createOrder"
      :loading="loading"
      width="100%"
      class="mt-2"
      color="primary"
      >Заказать
    </VBtn>
  </div>
</template>

<script>
import TableWithFilter from "@/components/ui/table/TableWithFilter";

export default {
  name: "CreateOrderBasket",
  components: { TableWithFilter },
  props: {
    products: {},
  },
  data() {
    return {
      loading: false,
      isVisibleTable: true,
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("product"),
          value: "name",
        },
        {
          text: this.$t("count"),
          value: "orderCount",
        },
        {
          text: this.$t("nameOfGroup"),
          value: "group_name",
        },
        {
          text: this.$t("unit"),
          value: "unitType",
        },
        {
          text: this.$t("action"),
          value: "action",
        },
      ];
    },
  },
  methods: {
    removeProduct(index) {
      this.products.splice(index, 1);
      localStorage.setItem("products_in_basket", JSON.stringify(this.products));
    },
    show() {
      this.isVisibleTable = true;
    },
    async createOrder() {
      const formData = new FormData();
      this.products.forEach((item, index) => {
        formData.append(`items[${index}].count`, item.orderCount);
        formData.append(`items[${index}].product_id`, item.id);
        formData.append(`items[${index}].unitTypeId`, item.unitType.id);
      });
      this.loading = false;
      try {
        await this.$http.post("orders/add-multiple", formData);
        this.$emit("orderCreated");
        this.setSuccess({
          text: this.$t("successfullySaved"),
        });
        localStorage.removeItem("products_in_basket");
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
